import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { AirportSearchService } from '../../service/airport-search.service';
import { ApiRequest, Filter, FilterComposit, FilterPredicate, Sort, SortCondition, PageInfo, ApiResponse } from '../../model/api-request';
import { Airport } from '../../model/airport';
import { CurrentAptService } from 'src/app/service/current-apt.service';
import { SortDescriptor,orderBy } from '@progress/kendo-data-query';
import { ConfigService } from 'src/app/service/config.service';


@Component({
  selector: 'app-airport-gridview',
  templateUrl: './airport-gridview.component.html',
  styleUrls: ['./airport-gridview.component.css']
})
export class AirportGridviewComponent implements OnInit {
  public css: string;
  public projectColor: string;
  public pageTitle = 'AirportSearch';
  public reportRouter: string;
  public apiRequest: ApiRequest;
  public apiResponse: ApiResponse;
   currentCity: string = null;
   items: any[] = null;
   gridView: GridDataResult = null;
   data: object[] = null;
   pageSize: number = 25;
   skip: number =0;

   public multiple = false;
   public allowUnsort = true;
   public sort: SortDescriptor[] = [{
     field: 'airportName',
     dir: 'asc'
   }];



  constructor(private airportSearchService: AirportSearchService,
              private router: Router,
              private route: ActivatedRoute,
              private config: ConfigService,
              private cas: CurrentAptService) {
      this.css = config.values.projectCSS;
      this.projectColor = config.values.projectColor;
      this.reportRouter = config.values.reportRouter;
   }

  ngOnInit() {
    this.cas.currentCity.subscribe(currentSearchCity => this.currentCity = currentSearchCity);

    console.log('current ' + this.currentCity);

    this.apiRequest = new ApiRequest();

    let filterPredicate1: Array<FilterPredicate>;
    let filterPredicate2: Array<FilterPredicate>;
    let filterPredicate3: Array<FilterPredicate>;
    let filterCompositArray: Array<FilterComposit>;
    let sortConditionArray: Array<SortCondition>;

    filterPredicate1 = [new FilterPredicate('AssociatedCity', 'String', this.currentCity, 'Contains')];
    filterPredicate2 = [new FilterPredicate('StateCode', 'String', this.currentCity, 'Contains')];
    filterPredicate3 = [new FilterPredicate('AirportName', 'String', this.currentCity, 'Contains')];
    filterCompositArray = [
      new FilterComposit(filterPredicate1, 'Or'),
      new FilterComposit(filterPredicate2, 'Or'),
      new FilterComposit(filterPredicate3, 'Or')];

    this.apiRequest.filter = new Filter(filterCompositArray, 'Or');



    sortConditionArray = [new SortCondition('AirportName', 'Ascending')];
    this.apiRequest.sort = new Sort(sortConditionArray);

    this.apiRequest.pageInfo = new PageInfo(0, 1, 5);

    this.airportSearchService.getMultiple(this.apiRequest).subscribe((result => {
      this.items = result.data;
      this.loadItems();
    }));
  }

  public cellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }) {
    if (columnIndex < 9) {
      this.cas.setCurrentAirport(dataItem.airportIdentifier);
      this.router.navigate(['\dashboard']);
    }
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.loaditemsforsorting();
}



private loaditemsforsorting(): void {
  this.gridView = {
      data: orderBy(this.items, this.sort),
      total: this.items.length
  };
}
  private loadItems(): void{
    this.gridView = {
      data : this.items.slice(this.skip, this.skip + this.pageSize),
      total: this.items.length
    };
  }
}
